// extracted by mini-css-extract-plugin
export default {"catalogByService":"c-i_eV"};